module.exports = __webpack_public_path__ + "img/item-3.152cd37.png";